<template>
  <div ph-autocapture>
    <HeaderDocs></HeaderDocs>
    <slot />
    <FooterDocs></FooterDocs>
    <CookieNotification></CookieNotification>
  </div>
</template>

<script setup>
import { useHead } from '#imports'
import HeaderDocs from '@saas/components/docs/Header'
import FooterDocs from '@saas/components/docs/Footer'
import CookieNotification from '@saas/components/CookieNotification'

useHead({
  titleTemplate: '',
  htmlAttrs: {
    lang: 'en',
  },
  bodyAttrs: {
    class: ['saas-page'],
  },
})
</script>
